<template>
  <FormBlock>
    <EverVisitedRadio v-model="pastVisit.visited" />
    <v-expand-transition>
      <div v-if="pastVisit.visited">
        <AppRow>
          <PastVisaNumber v-model="pastVisit.pastVisa.number" />
          <PastVisaDatePicker v-if="hasDate" v-model="pastVisit.pastVisa.dateOfIssue" />
        </AppRow>
      </div>
    </v-expand-transition>
  </FormBlock>
</template>

<script setup lang="ts">
import type { PastVisit } from '~/types';

const pastVisit = defineModel<PastVisit>({ required: true });
defineProps<{
  hasDate?: boolean;
}>();
</script>